/*
 * @Descripttion: 本地存储
 */

const local = {}
let userInfo = null

/* localStorage */
local.data = {
  set(table, settings) {
    let _set = JSON.stringify(settings)
    if (table === 'userInfo') {
      userInfo = settings
    }
    return localStorage.setItem(table, _set)
  },
  get(table) {
    let data
    try {
      if (table === 'userInfo') {
        if (userInfo) {
          return userInfo
        }
        userInfo = localStorage.getItem(table)
        userInfo = JSON.parse(userInfo)
      }
      data = localStorage.getItem(table)
      data = JSON.parse(data)
    } catch (err) {
      return null
    }
    return data
  },
  remove(table) {
    return localStorage.removeItem(table)
  },
  clear() {
    return localStorage.clear()
  },
}

/*sessionStorage*/
local.session = {
  set(table, settings) {
    let _set = JSON.stringify(settings)
    return sessionStorage.setItem(table, _set)
  },
  get(table) {
    let data = sessionStorage.getItem(table)
    try {
      data = JSON.parse(data)
    } catch (err) {
      return null
    }
    return data
  },
  remove(table) {
    return sessionStorage.removeItem(table)
  },
  clear() {
    return sessionStorage.clear()
  },
}

export default {
  install(Vue) {
    Vue.prototype.$local = local
  },
}
